import { Gender } from '@/externals/gyym'
import {
  ProfileUrgentRelationshipLabels,
  ProfileGenderLabels,
  UrgentRelationship,
  Options,
} from './types'

export { Gender } from '@/externals/gyym'

export const urgentRelationships: UrgentRelationship[] = [
  '配偶者',
  '家族・親族',
  '勤務先',
  'その他',
]

export const profileUrgentRelationshipLabels: ProfileUrgentRelationshipLabels =
  urgentRelationships.reduce(
    (acc, ur) => ({
      ...acc,
      [ur]: ur,
    }),
    {}
  )

export const urgentRelationshipsOptions: Options = urgentRelationships.map(
  (ur) => ({ text: ur, value: ur })
)

export const profileGenderLabels: ProfileGenderLabels = {
  [Gender.MEN]: '男性',
  [Gender.WOMEN]: '女性',
  [Gender.NONE]: '未設定',
}
